import * as React from "react";
import { SearchPageLogo } from "pages/styled";

const Logo = () => {
    return <SearchPageLogo>Google Books Finder</SearchPageLogo>;
};

export default React.memo(Logo);
